module.exports = __webpack_public_path__ + "bin/img/home_section03_visual.262f0a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_section03_visual.svg
// module id = becJ
// module chunks = 1